import { getStore, setStore, removeStore } from "./store";

export function getToken() {
  return getStore({ name: "token" });
}
export function setToken(token) {
  return setStore({ name: "token", content: token });
}
export function removeToken() {
  removeStore({ name: "token" });
}

export function getUser() {
  return getStore({ name: "user" });
}
export function setUser(user) {
  return setStore({ name: "user", content: user });
}
export function removeUser() {
  removeStore({ name: "user" });
}
